var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { map, get } from 'lodash';
import styled from 'styled-components';
import { Link, } from 'react-router-dom';
import { colors } from '../../helpers';
import { TitleComponent, SubTitleComponent, CardCategory, Horizontal, } from '../../commons';
const Header = styled.div `
  display: flex;
  flex-direction: column;
  padding: 5% 0 0 16px;
`;
const LinkWithCheck = (_a) => {
    var { stock, to, settingFields, description } = _a, props = __rest(_a, ["stock", "to", "settingFields", "description"]);
    return (((settingFields && (get(stock, 'unlimited') || get(stock, 'stockNumber') > 0)) || (description && description.length > 60))
        ? React.createElement(Link, Object.assign({ to: to }, props)) : React.createElement("span", Object.assign({}, props)));
};
export const Item = ({ data, width, read = null, theme, children = null, }) => (React.createElement(React.Fragment, null,
    React.createElement(Header, null,
        React.createElement(TitleComponent, { theme: theme, title: data.title }),
        React.createElement(SubTitleComponent, { theme: theme, title: data.description })),
    React.createElement(Horizontal, null, map(data.products, (value) => (React.createElement("div", { key: value.imageId, style: { flex: '0 0 auto' } },
        React.createElement(LinkWithCheck, { style: {
                textDecoration: 'none',
            }, settingFields: get(value, 'settingFields') && get(value, 'settingFields').length > 0, stock: get(value, 'stock'), description: value.description, to: {
                pathname: '/product',
                state: { product: value },
            } },
            React.createElement(CardCategory, { withTheme: true, width: width, read: read, isShadow: true, margin: "10px", stock: value.stock, name: value.reference, tva: value.tva, picture: value.picture, id: value.id, settingFields: value.settingFields, description: value.description, price: value.price, theme: theme, imageHeight: "20vh", imageWidth: "", children: children, backgroundColor: colors[get(theme, 'color.productBackground')] }))))))));
